(() => {
  if (window.GiestoProductReminder) return;
  window.GiestoProductReminder = { scan };
  const selector = '.giesto-product-reminder, [data-reminder-context]';
  const bound = new WeakSet();
  let sourceBox;
  const controllers = new Map();
  const intentKey = 'giesto:reminder-intent';
  const marker = 'giesto_reminder';
  let toastTimer;
  function showToast(message, error = false) {
    let toast = document.querySelector('[data-reminder-toast]');
    if (!toast) {
      toast = document.createElement('aside');
      toast.className = 'gs giesto-reminder-toast'; toast.dataset.reminderToast = '';
      toast.setAttribute('aria-atomic', 'true'); toast.hidden = true;
      toast.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4L19 6" fill="none" stroke="currentColor" stroke-width="1.5"/></svg><span></span>';
      document.body.append(toast);
    }
    (sourceBox?.closest('dialog[open]') || document.body).append(toast);
    clearTimeout(toastTimer);
    toast.setAttribute('role', error ? 'alert' : 'status'); toast.setAttribute('aria-live', error ? 'assertive' : 'polite');
    toast.dataset.error = String(error);
    toast.querySelector('path').setAttribute('d', error ? 'm7 7 10 10m0-10L7 17' : 'm5 12 4 4L19 6');
    // Never interpret the verified account email as HTML.
    toast.querySelector('span').textContent = message; toast.hidden = false;
    toastTimer = setTimeout(() => { toast.hidden = true; }, error ? 7000 : 6000);
  }
  function readIntent() { try { return JSON.parse(sessionStorage.getItem(intentKey) || 'null'); } catch { return null; } }
  function forgetIntent() {
    try { sessionStorage.removeItem(intentKey); } catch { /* URL alone never grants consent. */ }
    const url = new URL(location.href);
    if (url.searchParams.has(marker)) { url.searchParams.delete(marker); history.replaceState(history.state, '', url.pathname + url.search + url.hash); }
  }
  function createController(box) {
    const productId = box.dataset.productId, handle = box.dataset.productHandle, variantId = box.dataset.variantId || '', boxes = new Set();
    const config = { ...document.querySelector('[data-reminder-config]')?.dataset, ...box.dataset };
    const copy = Object.fromEntries(['idle', 'saved', 'canceled', 'error', 'readyMessage', 'unsubscribe', 'accountChanged', 'variantReady'].map(key => [key, config[`reminder${key[0].toUpperCase()}${key.slice(1)}`]]));
    let connected = false, authenticated = false, email = '';
    let actual = false, desired = false, busy = false, revision = 0, resumeIntent = null;
    function paint() {
      for (const item of boxes) {
        const button = item.querySelector('[data-reminder-toggle]');
        button.disabled = !connected; button.setAttribute('aria-pressed', String(desired)); button.setAttribute('aria-busy', String(busy));
        button.setAttribute('aria-label', `${desired ? copy.unsubscribe : copy.idle}${item.dataset.reminderName ? ': ' + item.dataset.reminderName : ''}`);
        item.querySelector('[data-reminder-label]').textContent = desired ? copy.saved : copy.idle;
      }
    }
    function press() {
      for (const item of boxes) {
        const button = item.querySelector('[data-reminder-toggle]'); button.removeAttribute('data-added'); void button.offsetWidth; button.dataset.added = 'true';
        setTimeout(() => button.removeAttribute('data-added'), 240);
      }
    }
    function endpoint(path) {
      const configured = config.proxyPath;
      if (!/^\/(apps|a|community|tools)\/[a-z0-9_-]+\/?$/i.test(configured || '')) throw new Error('Invalid proxy path');
      const origin = ['localhost', '127.0.0.1'].includes(location.hostname) ? 'http://127.0.0.1:8790' : location.origin;
      return new URL(`${configured.replace(/\/$/, '')}/${path}`, origin);
    }
    async function request(path, input) {
      const url = endpoint(path); if (!input) { url.searchParams.set('productId', productId); if (variantId) url.searchParams.set('variantId', variantId); }
      const response = await fetch(url, { method: input ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000),
        ...(input ? { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(input) } : {}) });
      if (response.status === 401) throw Object.assign(new Error('Sign in required'), { authenticationRequired: true });
      if (!response.ok) throw new Error('Reminder request failed'); const data = await response.json();
      if (typeof data.enrolled !== 'boolean' || !['none', 'pending', 'confirmed', 'notified', 'canceled'].includes(data.state)) throw new Error('Invalid response');
      return data;
    }
    const active = data => ['pending', 'confirmed'].includes(data.state);
    function identity(data) { authenticated = data.authenticated === true; email = typeof data.email === 'string' ? data.email : ''; }
    function beginLogin(target) {
      const returnUrl = new URL(location.href); returnUrl.searchParams.delete(marker); const nonce = crypto.randomUUID();
      // A bell in the bag's suggestions or favourites: the restore reopens that tab first.
      const bagTrigger = document.querySelector('.ghs-cart [data-gac-size-trigger][aria-expanded="true"]');
      const bag = bagTrigger ? (bagTrigger.closest('.ghs-wishlist') ? 'saved' : 'cart') : '';
      const intent = { productId, handle, variantId, bag, scrollY: window.scrollY, containerScrollY: document.querySelector('.page-wrapper')?.scrollTop || 0, subscribed: target, nonce, createdAt: Date.now(), returnPath: returnUrl.pathname + returnUrl.search + returnUrl.hash };
      try { sessionStorage.setItem(intentKey, JSON.stringify(intent)); } catch { showToast(copy.error, true); return; }
      const login = new URL(config.loginUrl, location.origin);
      if (login.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:customer_authentication\/login|account\/login)\/?$/i.test(login.pathname)) { forgetIntent(); showToast(copy.error, true); return; }
      returnUrl.searchParams.set(marker, nonce); const relative = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      login.searchParams.set('return_to', relative); if (/\/account\/login\/?$/.test(login.pathname)) login.searchParams.set('return_url', relative);
      location.assign(login.href);
    }
    function matchingIntent() {
      const value = readIntent(); if (!value) return null;
      if (!Number.isFinite(value.createdAt) || Date.now() - value.createdAt > 30 * 60000 || value.createdAt > Date.now() + 1000) { forgetIntent(); return null; }
      const current = new URL(location.href), nonce = current.searchParams.get(marker); current.searchParams.delete(marker);
      return value.productId === productId && (value.variantId || '') === variantId && value.handle === handle && typeof value.subscribed === 'boolean' && typeof nonce === 'string' && nonce === value.nonce && value.returnPath === current.pathname + current.search + current.hash ? value : null;
    }
    function notify() { showToast(actual ? (email ? (variantId ? copy.variantReady : copy.readyMessage).replace('__GIESTO_EMAIL__', email).replace('__GIESTO_SIZE__', box.dataset.reminderName || '') : copy.error) : copy.canceled, actual && !email); }
    async function pump() {
      if (busy) return; busy = true; ++revision; paint();
      try {
        const before = await request('status'), previousEmail = email, previousAuthenticated = authenticated;
        identity(before); actual = active(before);
        if (!authenticated) { const target = desired; desired = actual; beginLogin(target); return; }
        if (previousAuthenticated && previousEmail && email && previousEmail !== email) { desired = actual; resumeIntent = null; forgetIntent(); showToast(copy.accountChanged, true); return; }
        // Serialize writes while allowing immediate optimistic clicks. Rapid taps
        // settle on the latest requested state instead of racing HTTP toggles.
        while (desired !== actual) {
          const target = desired;
          const result = await request(target ? 'remind' : 'unremind', { productId, handle, ...(variantId ? { variantId } : {}), consent: true, reactivate: true, website: '' });
          actual = active(result); if (typeof result.email === 'string') email = result.email;
          if (actual !== target) throw new Error('Reminder state did not change');
        }
        if (resumeIntent) { forgetIntent(); resumeIntent = null; } paint(); notify();
        try { localStorage.setItem(`giesto:reminder:${productId}:${variantId}:updated`, String(Date.now())); } catch { /* Focus also refreshes other tabs. */ }
      } catch (error) {
        if (error.authenticationRequired) { const target = desired; desired = actual; beginLogin(target); }
        else {
          let reconciled = false;
          // A dropped response can follow a committed write. Reconcile without
          // replaying a toggle or claiming an unconfirmed save.
          try { const data = await request('status'); identity(data); actual = active(data); reconciled = actual === desired; } catch { /* Keep the last confirmed state. */ }
          desired = actual;
          if (reconciled && email) { if (resumeIntent) { forgetIntent(); resumeIntent = null; } notify(); }
          else showToast(copy.error, true);
        }
      } finally { busy = false; paint(); }
    }
    async function sync() {
      if (busy || ![...boxes].some(item => item.isConnected)) return; const current = ++revision;
      try {
        const data = await request('status'); if (current !== revision || busy) return;
        identity(data); actual = desired = active(data); connected = true; paint();
        const intent = matchingIntent(); if (intent && authenticated && document.readyState !== 'loading' && [...boxes].some(item => item.getClientRects().length)) { resumeIntent = intent; sourceBox = [...boxes].find(item => item.querySelector('[data-reminder-toggle]')?.getClientRects().length) || box; desired = intent.subscribed; press(); paint(); void pump(); }
      } catch { /* An unavailable service never invents a saved state. */ }
    }
    function add(item) {
      boxes.add(item); item.querySelector('[data-reminder-toggle]').addEventListener('click', () => {
        if (!connected) return; sourceBox = item; press(); if (!authenticated) { beginLogin(true); return; }
        desired = !desired; paint(); void pump();
      }); paint();
    }
    return { boxes, add, sync };
  }
  const visible = typeof IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) { visible.unobserve(entry.target); void controllers.get(entry.target.dataset.reminderKey)?.sync(); }
  }, { rootMargin: '200px' }) : null;
  function scan() {
    for (const [key, controller] of controllers) { for (const box of controller.boxes) if (!box.isConnected) controller.boxes.delete(box); if (!controller.boxes.size) controllers.delete(key); }
    document.querySelectorAll(selector).forEach(box => {
      if (bound.has(box) || !box.querySelector('[data-reminder-toggle]')) return;
      bound.add(box); box.dataset.reminderReady = 'true';
      const key = `${box.dataset.productId}:${box.dataset.variantId || ''}`; box.dataset.reminderKey = key;
      let controller = controllers.get(key);
      if (!controller) { controller = createController(box); controllers.set(key, controller); }
      controller.add(box);
      if (visible && !box.matches('.giesto-product-reminder')) visible.observe(box); else void controller.sync();
    });
  }
  // Only a tab-local, fresh, nonce-matched intent may reopen a transient size
  // drawer after account sign-in. A copied URL cannot subscribe anyone.
  async function restoreDrawerIntent() {
    if (document.readyState === 'loading') await new Promise(resolve => document.addEventListener('DOMContentLoaded', resolve, { once: true }));
    await new Promise(requestAnimationFrame);
    const intent = readIntent(); if (!intent?.variantId || !Number.isFinite(intent.createdAt) || Date.now() - intent.createdAt > 1800000 || intent.createdAt > Date.now() + 1000) return;
    const url = new URL(location.href), nonce = url.searchParams.get(marker); url.searchParams.delete(marker);
    if (!nonce || nonce !== intent.nonce || intent.returnPath !== url.pathname + url.search + url.hash) return;
    if ([...document.querySelectorAll(selector)].some(box => box.dataset.productId === intent.productId && box.dataset.variantId === intent.variantId && box.getClientRects().length)) return;
    const productBox = [...document.querySelectorAll('[data-gap-size-reminder]')].find(box => box.dataset.productId === intent.productId && box.dataset.variantId === intent.variantId && box.closest('giesto-store-product')?.dataset.productHandle === intent.handle);
    const product = productBox?.closest('giesto-store-product');
    if (product?.dataset.zpReady === 'true' && matchMedia('(min-width:1025px)').matches) {
      // The desktop PDP keeps its size choices in the existing buy dropdown.
      // Reopen that surface; the visible controller resumes the verified intent.
      const buy = product.querySelector('.gap__buy button[type="submit"]');
      if (buy && !buy.disabled) { buy.click(); scan(); return; }
    }
    const findTrigger = () => [...document.querySelectorAll('[data-gac-size-trigger][data-gac-reminders]')].find(button => button.dataset.productId === intent.productId && button.dataset.productHandle === intent.handle);
    let trigger = findTrigger();
    // The bag's rails exist only while it is open: reopen it and wait for the card.
    if (!trigger && (intent.bag === 'cart' || intent.bag === 'saved')) {
      document.dispatchEvent(new CustomEvent('giesto:cart:open', { detail: { tab: intent.bag } }));
      trigger = await new Promise(resolve => {
        const done = found => { observer.disconnect(); clearTimeout(timer); resolve(found); };
        const observer = new MutationObserver(() => { const found = findTrigger(); if (found) done(found); });
        observer.observe(document.documentElement, { childList: true, subtree: true });
        const timer = setTimeout(() => done(findTrigger() || null), 8000);
      });
    }
    if (!trigger) return;
    await customElements.whenDefined('giesto-store-size-picker');
    if (Number.isFinite(intent.scrollY)) window.scrollTo({ top: intent.scrollY, behavior: 'instant' });
    if (Number.isFinite(intent.containerScrollY)) document.querySelector('.page-wrapper')?.scrollTo({ top: intent.containerScrollY, behavior: 'instant' });
    document.dispatchEvent(new CustomEvent('giesto:size-picker:open', { detail: { trigger } }));
  }
  function refresh() { scan(); controllers.forEach(controller => { void controller.sync(); }); }
  document.addEventListener('giesto:reminders:scan', scan);
  new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches(selector) || node.querySelector(selector))))) scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan); window.addEventListener('pageshow', refresh); window.addEventListener('focus', refresh);
  window.addEventListener('storage', event => { if (event.key?.startsWith('giesto:reminder:')) refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); }); scan(); void restoreDrawerIntent();
})();
